export interface Part {
  RSPF_PROD_N: string;
  RSPF_DESC: string;
  RSPF_SEARCH: string;
  RSIL_ONHAND: number;
}
